// Shared visual tokens for the CBCT viewer chrome (panels, stages, tool rail).
// Kept in one module so the extracted sub-components stay in visual lockstep.
export const SHELL = '#eef1f4';
export const WHITE = '#ffffff';
export const BORDER = '#e0e6eb';
export const INK = '#1c2734';
export const TEXT = '#3c4954';
export const MUTED = '#5b6774';
export const MUTED2 = '#7e8b96';
export const TEAL = '#0e97b0';
export const TEAL_DK = '#0a7f96';
export const TEAL_BORDER = '#8fd0dc';
export const TEAL_TINT = 'rgba(14,151,176,.12)';
export const AMBER = '#a9760f';
export const AMBER_BORDER = '#e3c07f';
export const AMBER_TINT = 'rgba(201,138,30,.14)';
export const AMBER_ACCENT = '#e6b34a';
export const GREEN = '#178a5c';
export const TILE = '#f5f7f9';
export const CARD = '#f7f9fb';
export const MONO = "ui-monospace,'SF Mono','Cascadia Code',monospace";

export const cn = (...classes: Array<string | undefined | null | false>): string =>
    classes.filter(Boolean).join(' ');

/**
 * Contain-fit sizing for an image box inside a pane. The pane must declare
 * `containerType: 'size'` so the cqw/cqh units below resolve against it.
 *
 * `max-h-full max-w-full` + `aspect-ratio` alone cannot do this: max-*
 * constraints only clamp, so an auto-sized box falls back to its content's
 * intrinsic size — for a canvas that's the backing-store attributes, whose
 * ResizeObserver then re-derives them from the too-small layout, a feedback
 * loop that settles into a small centered box. An explicit width computed
 * from the container's size breaks the loop with exact contain math; the
 * aspect ratio derives the height.
 *
 * Typed structurally (not React.CSSProperties): consumer apps hold different
 * csstype versions, and a nominal CSSProperties from this package's react
 * types fails assignability against theirs. Plain string fields are
 * assignable to every csstype Properties shape.
 */
export function containBoxStyle(aspect: number): { aspectRatio: string; width: string } {
    return {
        aspectRatio: `${aspect}`,
        width: `min(100cqw, calc(100cqh * ${aspect}))`
    };
}
